import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, FormControlLabel } from "@mui/material";
const CrieMenuIndirectSeparate = ({ isMenuOpen, alldata, handleCheckboxChange, checked, handleSearch, isSearch }) => {
    // Separate data by node_type
    const persons = React.useMemo(() => alldata?.filter(item => item.node_type === "person") || [], [alldata]);
    const organizations = React.useMemo(() => alldata?.filter(item => item.node_type === "organization") || [], [alldata]);
    return (
        <>
            {
                isMenuOpen &&
                <div className="crie-filter-inner-container-drop">
                    <div>
                        {
                            isSearch &&
                            <div className="crie_input_cont">
                                <input type="text" placeholder="Type to search" className="crie_input" onChange={(e) => handleSearch(e?.target?.value)} />
                            </div>
                        }
                        {persons.length > 0 && (
                            <div>
                                <h3 className='useralldata-indirect'>Prospects</h3>
                                {persons.map(item => (
                                    <div className="location_filter_leads_crie">
                                        <div className="AI-leader-checkbox-and-data-list">
                                            <div className="checkbox-select-data">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={checked?.includes(item?.joi_id)}
                                                            value={item?.joi_id}
                                                            onChange={(event) =>
                                                                handleCheckboxChange(event, item?.joi_id)
                                                            }
                                                            className="checkbox-green location_filter_checkbox"
                                                            color="success"
                                                        />
                                                    }
                                                    label={<MenuItem className="menuitems">{item.name === "Jp Nauseef" ? "JP Nauseef" : item.name}</MenuItem>}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {organizations.length > 0 && (
                            <div>
                                <h3 className='useralldata-indirect'>Organizations</h3>
                                {organizations.map(item => (
                                    <div className="location_filter_leads_crie">
                                        <div className="AI-leader-checkbox-and-data-list">
                                            <div className="checkbox-select-data">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={checked?.includes(item?.joi_id)}
                                                            value={item?.joi_id}
                                                            onChange={(event) =>
                                                                handleCheckboxChange(event, item?.joi_id)
                                                            }
                                                            className="checkbox-green location_filter_checkbox"
                                                            color="success"
                                                        />
                                                    }
                                                    label={<MenuItem className="menuitems">{item.name === "Jp Nauseef" ? "JP Nauseef" : item.name}</MenuItem>}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            }
        </>
    );
};
export default CrieMenuIndirectSeparate;